export default function() {
    return (authentication._shouldAllowGoogleOAuth || authentication._shouldAllowTwitterOAuth || authentication._shouldAllowFacebookOAuth || authentication._shouldAllowLinkedInOAuth || authentication._shouldAllowAzureOAuth)
}